module.exports = __webpack_public_path__ + "img/nutrition_4.7fb4661e.jpg";